import { render, staticRenderFns } from "./cash_reduce_order.vue?vue&type=template&id=c20f1976&scoped=true"
import script from "./cash_reduce_order.vue?vue&type=script&lang=js"
export * from "./cash_reduce_order.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/cash-account.scss?vue&type=style&index=0&id=c20f1976&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20f1976",
  null
  
)

export default component.exports